import React from 'react'
import { LinkProps } from 'react-router'
import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackSideMenuEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { store } from '@core/Store'
import { toggleIsHamburgerMenuOpen } from '../../Store'
import { ExternalLinkIconStyled, ExternalLinkStyled, LinkStyled } from './HamburgerMenu.styles'

export const HamburgerMenuLink = ({ children, ...attribs }: LinkProps) => (
  <LinkStyled
    {...attribs}
    onClick={e => {
      store.dispatch(toggleIsHamburgerMenuOpen(false))
      trackSideMenuEvent(keys.hamburgerMenuClicked, { item: attribs.id ?? '' })
      attribs.onClick?.(e)
    }}
  >
    {children}
  </LinkStyled>
)

export const HamburgerMenuExternalLink = ({
  children,
  ...attribs
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <ExternalLinkStyled
    href={attribs.href}
    target='_blank'
    {...attribs}
    onClick={e => {
      trackSideMenuEvent(keys.hamburgerMenuClicked, { item: attribs.id ?? '' })
      attribs.onClick?.(e)
    }}
  >
    {children} <ExternalLinkIconStyled size='1em' type='externalLink' />
  </ExternalLinkStyled>
)
